import * as React from 'react';
import type { SVGProps } from 'react';
const SvgPageWithCurl = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={204}
    height={204}
    fill="none"
    {...props}
  >
    <path
      fill="url(#Page_with_curl_svg__a)"
      d="M25.725 19.773a6.375 6.375 0 0 1 6.375-6.375h128.496a6.375 6.375 0 0 1 6.375 6.375v158.08c0 7.041-5.709 12.75-12.75 12.75H51.225c-14.084 0-25.5-11.417-25.5-25.5z"
    />
    <path
      fill="url(#Page_with_curl_svg__b)"
      d="M25.725 19.773a6.375 6.375 0 0 1 6.375-6.375h128.496a6.375 6.375 0 0 1 6.375 6.375v158.08c0 7.041-5.709 12.75-12.75 12.75H51.225c-14.084 0-25.5-11.417-25.5-25.5z"
    />
    <path
      fill="url(#Page_with_curl_svg__c)"
      fillOpacity={0.74}
      d="M25.725 19.773a6.375 6.375 0 0 1 6.375-6.375h128.496a6.375 6.375 0 0 1 6.375 6.375v158.08c0 7.041-5.709 12.75-12.75 12.75H51.225c-14.084 0-25.5-11.417-25.5-25.5z"
    />
    <path
      fill="url(#Page_with_curl_svg__d)"
      fillOpacity={0.39}
      d="M25.725 19.773a6.375 6.375 0 0 1 6.375-6.375h128.496a6.375 6.375 0 0 1 6.375 6.375v158.08c0 7.041-5.709 12.75-12.75 12.75H51.225c-14.084 0-25.5-11.417-25.5-25.5z"
    />
    <path
      fill="url(#Page_with_curl_svg__e)"
      d="M25.725 19.773a6.375 6.375 0 0 1 6.375-6.375h128.496a6.375 6.375 0 0 1 6.375 6.375v158.08c0 7.041-5.709 12.75-12.75 12.75H51.225c-14.084 0-25.5-11.417-25.5-25.5z"
    />
    <path
      fill="url(#Page_with_curl_svg__f)"
      d="M25.725 19.773a6.375 6.375 0 0 1 6.375-6.375h128.496a6.375 6.375 0 0 1 6.375 6.375v158.08c0 7.041-5.709 12.75-12.75 12.75H51.225c-14.084 0-25.5-11.417-25.5-25.5z"
    />
    <path
      fill="url(#Page_with_curl_svg__g)"
      d="M25.725 19.773a6.375 6.375 0 0 1 6.375-6.375h128.496a6.375 6.375 0 0 1 6.375 6.375v158.08c0 7.041-5.709 12.75-12.75 12.75H51.225c-14.084 0-25.5-11.417-25.5-25.5z"
    />
    <path
      fill="url(#Page_with_curl_svg__h)"
      d="M25.725 19.773a6.375 6.375 0 0 1 6.375-6.375h128.496a6.375 6.375 0 0 1 6.375 6.375v158.08c0 7.041-5.709 12.75-12.75 12.75H51.225c-14.084 0-25.5-11.417-25.5-25.5z"
    />
    <path
      fill="url(#Page_with_curl_svg__i)"
      d="M25.725 19.773a6.375 6.375 0 0 1 6.375-6.375h128.496a6.375 6.375 0 0 1 6.375 6.375v158.08c0 7.041-5.709 12.75-12.75 12.75H51.225c-14.084 0-25.5-11.417-25.5-25.5z"
    />
    <path
      fill="url(#Page_with_curl_svg__j)"
      d="M82.502 162.911a6.375 6.375 0 0 0-6.376 6.375v.577c0 8.064-10.535 18.828-21.241 20.432v.308h107.891c12.879 0 23.319-10.441 23.319-23.32a4.37 4.37 0 0 0-4.372-4.372z"
    />
    <path
      fill="url(#Page_with_curl_svg__k)"
      d="M82.502 162.911a6.375 6.375 0 0 0-6.376 6.375v.577c0 8.064-10.535 18.828-21.241 20.432v.308h107.891c12.879 0 23.319-10.441 23.319-23.32a4.37 4.37 0 0 0-4.372-4.372z"
    />
    <path
      fill="url(#Page_with_curl_svg__l)"
      d="M82.502 162.911a6.375 6.375 0 0 0-6.376 6.375v.577c0 8.064-10.535 18.828-21.241 20.432v.308h107.891c12.879 0 23.319-10.441 23.319-23.32a4.37 4.37 0 0 0-4.372-4.372z"
    />
    <path
      fill="url(#Page_with_curl_svg__m)"
      d="M82.502 162.911a6.375 6.375 0 0 0-6.376 6.375v.577c0 8.064-10.535 18.828-21.241 20.432v.308h107.891c12.879 0 23.319-10.441 23.319-23.32a4.37 4.37 0 0 0-4.372-4.372z"
    />
    <path
      fill="url(#Page_with_curl_svg__n)"
      d="M82.502 162.911a6.375 6.375 0 0 0-6.376 6.375v.577c0 8.064-10.535 18.828-21.241 20.432v.308h107.891c12.879 0 23.319-10.441 23.319-23.32a4.37 4.37 0 0 0-4.372-4.372z"
    />
    <path
      fill="url(#Page_with_curl_svg__o)"
      d="M82.502 162.911a6.375 6.375 0 0 0-6.376 6.375v.577c0 8.064-10.535 18.828-21.241 20.432v.308h107.891c12.879 0 23.319-10.441 23.319-23.32a4.37 4.37 0 0 0-4.372-4.372z"
    />
    <path
      fill="#9C96A2"
      fillRule="evenodd"
      d="M52.582 63.95a.51.51 0 0 0-.512.51v5.502c0 .282.23.512.512.512h87.679c.282 0 .511-.23.511-.512V64.46a.51.51 0 0 0-.511-.512zm0 19.124a.51.51 0 0 0-.512.512v5.5c0 .284.23.513.512.513h87.679c.282 0 .511-.23.511-.512v-5.501a.51.51 0 0 0-.511-.512zm-.512 19.637c0-.283.23-.512.512-.512h87.679c.282 0 .511.229.511.512v5.501a.51.51 0 0 1-.511.512H52.582a.51.51 0 0 1-.512-.512zm.512 18.613a.51.51 0 0 0-.512.512v5.501c0 .283.23.512.512.512h56.202a.51.51 0 0 0 .512-.512v-5.501a.51.51 0 0 0-.512-.512z"
      clipRule="evenodd"
    />
    <defs>
      <linearGradient
        id="Page_with_curl_svg__a"
        x1={38.275}
        x2={162.189}
        y1={118.087}
        y2={118.087}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#EAE3F2" />
        <stop offset={0.83} stopColor="#E0D9E7" />
      </linearGradient>
      <linearGradient
        id="Page_with_curl_svg__c"
        x1={166.593}
        x2={164.174}
        y1={68.316}
        y2={68.316}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={1} stopColor="#fff" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="Page_with_curl_svg__d"
        x1={100.853}
        x2={100.853}
        y1={12.47}
        y2={15.477}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={1} stopColor="#fff" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="Page_with_curl_svg__e"
        x1={24.637}
        x2={27.487}
        y1={43.901}
        y2={43.901}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#BDB3C8" />
        <stop offset={1} stopColor="#BDB3C8" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="Page_with_curl_svg__f"
        x1={29.47}
        x2={33.096}
        y1={184.535}
        y2={183.015}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#BDB3C8" />
        <stop offset={1} stopColor="#BDB3C8" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="Page_with_curl_svg__g"
        x1={35.729}
        x2={38.575}
        y1={188.434}
        y2={185.2}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#BDB3C8" />
        <stop offset={1} stopColor="#BDB3C8" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="Page_with_curl_svg__h"
        x1={46.014}
        x2={47.437}
        y1={193.673}
        y2={188.563}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#BDB3C8" />
        <stop offset={1} stopColor="#BDB3C8" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="Page_with_curl_svg__i"
        x1={54.164}
        x2={54.293}
        y1={191.862}
        y2={189.275}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#BDB3C8" />
        <stop offset={1} stopColor="#BDB3C8" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="Page_with_curl_svg__j"
        x1={120.49}
        x2={120.49}
        y1={165.302}
        y2={190.603}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#DFD5EA" />
        <stop offset={1} stopColor="#C8B2DE" />
      </linearGradient>
      <linearGradient
        id="Page_with_curl_svg__k"
        x1={106.408}
        x2={106.408}
        y1={191.599}
        y2={184.028}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#AB89CA" />
        <stop offset={1} stopColor="#C8B3DE" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="Page_with_curl_svg__m"
        x1={76.892}
        x2={78.402}
        y1={164.768}
        y2={166.531}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#A8A1AE" />
        <stop offset={1} stopColor="#C6BFCD" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="Page_with_curl_svg__n"
        x1={73.819}
        x2={76.317}
        y1={167.959}
        y2={170.264}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#A8A1AE" />
        <stop offset={1} stopColor="#C6BFCD" stopOpacity={0} />
      </linearGradient>
      <radialGradient
        id="Page_with_curl_svg__b"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(0 -33.8672 86.8594 0 53.615 190.603)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.276} stopColor="#EAE7ED" />
        <stop offset={1} stopColor="#EAE7EE" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="Page_with_curl_svg__l"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="rotate(-24.343 521.407 -98.8)scale(108.018 50.7082)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.949} stopColor="#E7DFEF" stopOpacity={0} />
        <stop offset={0.995} stopColor="#FFFCFF" />
      </radialGradient>
      <radialGradient
        id="Page_with_curl_svg__o"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(14.60062 6.53185 -30.94998 69.18242 66.519 171.865)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#A8A1AE" />
        <stop offset={1} stopColor="#C6BFCD" stopOpacity={0} />
      </radialGradient>
    </defs>
  </svg>
);
export default SvgPageWithCurl;
